/**
 * aramRelicPads — Murder Bridge health relics on both lane sides (AR-R41).
 * Outer: just beyond outer turret range toward mid (wiki HA).
 * Inner: between outer and inhibitor turret.
 * Near (−X) and far (+X) rails alternate so pads read as “along the sides”.
 */

import { ARAM_BRIDGE_WIDTH, lolToSandbox } from './aramScale.js';
import { ARAM_STRUCTURE_ALONG, ARAM_STRUCTURE_TIERS } from './aramLayout.js';

const PAD_OUTSET = ARAM_BRIDGE_WIDTH * 0.1;
const PAD_X_NEAR = -(ARAM_BRIDGE_WIDTH / 2 + PAD_OUTSET);
const PAD_X_FAR = ARAM_BRIDGE_WIDTH / 2 + PAD_OUTSET;
const OUTER_RANGE = lolToSandbox(ARAM_STRUCTURE_TIERS.outer.attackRange);

const blueOuterRelicZ = ARAM_STRUCTURE_ALONG.outer - OUTER_RANGE;
const blueInnerRelicZ =
  (ARAM_STRUCTURE_ALONG.outer + ARAM_STRUCTURE_ALONG.inhibTurret) / 2;

/**
 * Four health relic pads: outer pair on −X rail, inner pair on +X rail.
 */
export const ARAM_RELIC_PADS = [
  { id: 'relic-blue-outer', x: PAD_X_NEAR, z: blueOuterRelicZ },
  { id: 'relic-blue-inner', x: PAD_X_FAR, z: blueInnerRelicZ },
  { id: 'relic-red-inner', x: PAD_X_FAR, z: -blueInnerRelicZ },
  { id: 'relic-red-outer', x: PAD_X_NEAR, z: -blueOuterRelicZ }
];
